import React, { useEffect } from 'react';

const EmployeeProjectPagination = ({ handlePageClick, limit, employeesByProject, nextPage, prevPage, input, pageCount, setpageCount, initialPage, finalPage, employeesByProjectActive, inactiveEmployees }) => {

    useEffect(() => {
        if (inactiveEmployees) {
            setpageCount(Math.ceil(employeesByProject.totalRecords / limit));
        } else {
            setpageCount(Math.ceil(employeesByProjectActive.length / limit));
        }
    }, [employeesByProject, employeesByProjectActive, limit]);

    const pageNumbers: number[] = [];

    for (let i = 1; i <= pageCount; i++) {
        pageNumbers.push(i);
    };

    return (
        <nav className='pagination' aria-label='...'>
            <ul className='pagination justify-content-center mb-0'>
                <li className={input.currentPage === 1 ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/project/detail/${input.idProject}#employee`} aria-label="Initial" onClick={() => initialPage()}>
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                <li className={input.currentPage === 1 ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/project/detail/${input.idProject}#employee`} aria-label="Previous" onClick={() => prevPage()}>
                        <span aria-hidden="true">&lt;</span>
                    </a>
                </li>
                {pageNumbers.map(num => (
                    <li className={input.currentPage === num ? 'page-item active' : 'page-item'} key={num}>
                        <a className='page-link' href={`/project/detail/${input.idProject}#employee`} onClick={() => handlePageClick(num)}>{num}</a>
                    </li> 
                ))}
                <li className={input.currentPage === pageCount ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/project/detail/${input.idProject}#employee`} aria-label="Next" onClick={() => nextPage()}>
                        <span aria-hidden="true">&gt;</span>
                    </a>
                </li>
                <li className={input.currentPage === pageCount ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/project/detail/${input.idProject}#employee`} aria-label="Final" onClick={() => finalPage()}>
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default EmployeeProjectPagination;